import { Divider, FormControl, Grid, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useMediaQuery } from "@mui/material";
import { makeStyles } from "@mui/styles";
import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Input } from '../../components';
import { Form, useForm } from "../../components/form/UseForm";
import Custompopup from "../../components/popup/Custompopup";
import { validateEmail } from '../../components/validators/inputValidators';
import { OnLoginAsyncForOBS, holidayListApi, whoamiAPI } from "../../redux/actions";
import { createAppointment, getQuery, regNo } from '../../redux/actions/feedbackFormSlice';
import { useAppDispatch } from "../../store/customHooks";
import { MuiDatePicker } from './dateComponent';
import { fields } from './fields';
import Header from "./header";
import ThankYou from "./thankyou";
//Code For Banner Add 
//import BannerImage from '../../components/images/Website Banner 851x315.jpg';
//import BannerImageForMobile from '../../components/images/Website Banner 1080x1080.jpg'




const useStyles = makeStyles({
    headings: {
        fontSize: ".875rem",
        color: "#00095b"
    },

    buttun: {
        backgroundColor: "#1C396D !important"
    },
    root: {
        backgroundColor: "#fff",
        padding: "10px",

    },
    bg: {
        backgroundColor: "#ddd",

    }


});
const validateContactNumber = (inputText: any) => {
    const phoneNo = /^\d{10}$/;

    if (inputText.match(phoneNo)) {
        return true;
    } else {
        return false;
    }

};
export const ValidateVINNumber = (inputText: any) => {
    const no = /\b[(A-H|J-N|P|R-Z|0-9)]{17}\b/;
    if (inputText.match(no)) {
        return true;
    } else {
        return false;
    }
}

const AuthrizedAppointmentBooking = () => {
    const isMobile = useMediaQuery('(max-width:600px)');
    const isTablet = useMediaQuery('(min-width:600px) and (max-width:960px)');
    const classes = useStyles();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [thankyou, setThankyou] = useState(false)
    const [originalVin, setOriginalVin] = useState("");
    const [originalRegNo, setOriginalRegNo] = useState("");

    const initialFValues = {
        regNo: "",
        mobileNumber: "",
        name: "",
        state: "",
        city: "",
        dealer: "",
        serviceAdvisor: "",
        serviceType: "",
        serviceSubType: "",
        isPickupDropRequired: "",
        verbatim: ""
        //email:"test@GamesOutlined.com"
    };
 
    const [open, setOpen] = useState(false)
    const handleClose = () => {
        setOpen(false)
        loadDropDownOptions("state", "955287", "")
        loadDropDownOptions("serviceType", "941822", "")
        validate({ ['mobileOTP']: "" }, "")
        setFormFields1(fields)
    };
    const validate = (fieldValues = values, msg: any) => {
        let temp = { ...errors };
        formFields?.forEach((f: any) => {
            if (f.key in fieldValues) {
                temp[f.key] = fieldValues[f.key] ? "" : "Please enter your " + f.label;
            }
        })
        if ("mobileNumber" in fieldValues) {
            temp["mobileNumber"] = fieldValues["mobileNumber"].length == 10 ? "" : msg
        }
        if ("mobileOTP" in fieldValues) {
            temp["mobileOTP"] = fieldValues["mobileOTP"] ? "" : msg
        }
        if ("vin" in fieldValues) {
            temp["vin"] = fieldValues["vin"] ? "" : msg
        }
        if ("appointmentDate" in fieldValues) {
            temp["appointmentDate"] = fieldValues["appointmentDate"] ? "" : msg
            //added
        }
        if ("appointmentTime" in fieldValues) { //added by  rajeev
            temp["appointmentTime"] = msg //msg
            //added
        }
        if ("email" in fieldValues) {

            temp.email = fieldValues.email
                ? !validateEmail(fieldValues.email)
                ? "Please enter a valid email address"
                : ""
                : "";

        }
        if ("firstName" in fieldValues) {
            temp["firstName"] = fieldValues["firstName"] ? "" : "Please enter your first name"

        }
        setErrors({
            ...temp,
        });

        // Check if any field has error return false else true.
        if (fieldValues == values) return Object.values(temp).every((x) => x == "");
    };
    // Custom useForm hook.
    const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
        useForm({ initialFValues, validateOnChange: true, validate });

    const [isButtonEnabled, setIsButtonEnabled] = useState<boolean>(false);//added
    // console.log("values check", values)
    const [error, setError] = useState("");
    const [disabledMobileNo, setDisabledMobileNo] = useState(true)
    const [verifiedVINandREG, setOtpVerifiedVINandREG] = useState(false)
    const [CampaignsData, setCampaignsData] = useState<any>([])
    const [disableRegNo, setDisabledRegNo] = useState(false)
    const [branchStartTime, setBranchStartTime] = useState('');//added no use
    const [branchEndTime, setBranchEndTime] = useState(''); //added no use
    let token: any = localStorage.getItem("APPOINTMENT_AUTH_DATA");
    const authData = JSON.parse(token);

    const StartTimeAndEndTime = () => {

        let getDealerStartAndEndTime: any = {};
        getDealerStartAndEndTime = fields?.find((el: any) => el.key == 'dealer')?.options?.find((el: any) => el.BranchID == values.dealer);

        const sDate = getDealerStartAndEndTime?.BranchStartTime;
        const eDate = getDealerStartAndEndTime?.BranchEndTime;
        const branchSTime = sDate?.split('T')[1].slice(0, 5);//values.branchStartTime?.split('T')[1];//added
        const branchEndTime = eDate?.split('T')[1].slice(0, 5); //dealerEndTime?.split('T')[1]; ////added

        return { branchSTime, branchEndTime }
    }
    const validateAppointmentTime = (selectedTime: any) => { //added for validate dealerTime
        //  console.log(formFields1)

        const getTimes = StartTimeAndEndTime()

        const selectedHour = selectedTime//selectedTime.getHours();
        // You may need to further validate minutes if needed

        if (selectedHour >= getTimes?.branchSTime && selectedHour <= getTimes?.branchEndTime) {
            return true;

        } else {

            return false;
        }

    }
    //End added 

    useEffect(() => {
        if (!authData) {

            whoami()
        }

    }, []);
    const whoami = async () => {
        const res: any = await dispatch(whoamiAPI(""));
        if (res?.payload.statusCode === 200) {
            autoLogin()
        }
    }

    const autoLogin = async () => {
        const res: any = await dispatch(OnLoginAsyncForOBS());
        if (res?.payload?.IsLogInSuccessful) {
            localStorage.setItem("APPOINTMENT_AUTH_DATA", JSON.stringify(res?.payload));
        }
    }

    const clearSession = () => {
        localStorage.clear()
    }
    const [formFields, setFormFields]: any = useState([
        // { key: "vin", label: "VIN", type: 'text', helperText: "Please enter your VIN", required: true, disabled: false },
        { key: "model", label: "Model", type: 'text', helperText: "Please enter model", required: false, disabled: false },
    ])

    const [formFields1, setFormFields1]: any = useState([]);
    const [referenceNumber, setReferenceNumber] = useState([])
    // console.log("formFields1", formFields1);

    const onInputChange = async (e: any) => {
        setError("")
        const { name, value } = e.target;
        if (name === "mobileNumber") {
            if (value.length <= 10) {
                let getValidatedNumber = validateContactNumber(value);
                setValues({ ...values, [name]: value, mobileOTP: "" });
                setFormFields1([])

                if (getValidatedNumber) {
                    validate({ [name]: value }, "");

                } else {
                    validate({ [name]: value }, "Please enter a valid 10-digit mobile number");
                }
            } else {
                validate({ [name]: value }, "");

            }
        } else if (name === 'vin') {
            setOtpVerifiedVINandREG(false)

            if (value != " " && value.length <= 17) {

                setValues({ regNo: "", [name]: value, model: "" });
                if (ValidateVINNumber(value)) {
                    validate({ [name]: value }, " ");
                }
            } else {
                validate({ [name]: value }, "Please enter 17 characters VIN");


            }
        } else if (name === 'regNo') {
            setOtpVerifiedVINandREG(false)
            if (value != " " && value?.trim().length <= 12) {
                setValues({ vin: "", [name]: value, model: "" });
                validate({ [name]: value }, " ");
            } else {
                validate({ [name]: value }, "Please enter 12 characters RegNo");
            }
        } else if (name === "appointmentDate") {
            let d = moment(new Date(value)).format('YYYY-MM-DD') //added

            const payload = {
                AuthenticationToken: authData?.AuthenticationToken,
                ManagerKey: authData?.ProfileManagerKey,
                "AppointmentDate": d + " " + "00:00",
                //  "AppointmentDate": d + " " + dateValue,

                "BranchID": values.dealer
            };
            const res: any = await dispatch(holidayListApi(payload));
            if (res?.payload?.Data?.IsRequestSuccessful == true) {
                setValues({ ...values, [name]: "" });
                validate({ [name]: "" }, res?.payload?.Data?.ErrorMsg);
            } else {
                if (value != " ") {
                    setValues({ ...values, [name]: value });
                    validate({ [name]: value }, "");
                }
            }

        } else {
            if (value != " ") {
                setValues({ ...values, [name]: value });
                validate({ [name]: value }, "");
            }
        }

        if (name === "appointmentTime") { //added by Rajeev 
            // Check if the selected appointment time is within the dealer's working hours
            const getTime = validateAppointmentTime(value);
            if (getTime) {

            } else {

                // Show error message if the selected time is outside working hours
                const getTimes = StartTimeAndEndTime()
                validate({ [name]: value }, `Please select your preferred time slot between ${getTimes?.branchSTime} to ${getTimes?.branchEndTime}`);
            }
        }
        if (name === "state") {
            setValues({ ...values, [name]: value, city: "", dealer: "", serviceAdvisor: "" });
            loadDropDownOptions("city", "955288", "StateID=" + value)
        }
        if (name === "city") {
            setValues({ ...values, [name]: value, dealer: "", serviceAdvisor: "" });

            loadDropDownOptions("dealer", "955286", "CityID=" + value)

        }
        if (name === "dealer") {
            setValues({ ...values, [name]: value, serviceAdvisor: "", appointmentDate: "", appointmentTime: "" });
            validate({ appointmentTime: "" }, "");

            let date: any = new Date();

            loadDropDownOptions("serviceAdvisor", "941816", `(BranchID = ${value})  AND ((FromDate <= '${date?.toISOString().slice(0, date?.toISOString().indexOf('T')).toString()}' AND ToDate >= NULL) OR ToDate is NULL)`)
        }

        if (name === "serviceType") {

            loadDropDownOptions("serviceSubType", "942144", `(ISNULL(ServiceContractID,0) = ${value} OR ISNULL(ServiceContractID,0) = 0)`)
            // console.log("formFields1", formFields1)
            //  const value=values.serviceType

            setValues({ ...values, serviceSubType: value === 38 ? 15 : value === 47 ? 14 : value === 46 ? 14 : "", [name]: value });

        }

        if (name === "email") {
            if (value.length <= 1) {
              //  setEnableTimer(false);
               let getValidatedEmail = validateEmail(value);
              //  setValues({ ...values, [name]: value});
               // setFormFields1([])
                if (getValidatedEmail) {
                    validate({ [name]: value }, "");
                } else {
                    validate({ [name]: value }, "Please enter a valid Email");
                }
            } 
        }

        
    };

    const onSubmit = async (e: any) => {  //need to update time 
        e.preventDefault()
        let date = moment(new Date(values?.appointmentDate)).format("YYYY-MM-DD") + " " + values.appointmentTime;

        let payload = {
            AuthenticationToken: authData?.AuthenticationToken,
            ManagerKey: authData?.ProfileManagerKey,
            "BranchID": values.dealer,
            "RegistrationNo": originalRegNo, //values.regNo,
            "VIN": originalVin,//values.vin,
            "FirstName": values.firstName,
            "LastName": values.lastName,
            "Mobile": values.mobileNumber,
            "AdvisorID": values.serviceAdvisor ? values.serviceAdvisor : 0,
            "AppointmentDate": date,
            "SoureID": 4,
            "ServiceTypeID": values.serviceType ? values.serviceType : 0,
            "ServiceSubTypeID": values.serviceSubType ? values.serviceSubType : 0,
            "CustomerVerbatim": values.verbatim,
            "ModelID": 0,
            "IsPickDropRequired": values.isPickupDropRequired ? values.isPickupDropRequired : 0,
            "EmailAddress": values.email,
            "KMReading": parseInt(values?.KMReading)
        }
        const res = await dispatch(createAppointment(payload));

        if (res?.payload?.Data?.IsRequestSuccessful) {
            setValues({})
            setThankyou(true)
            setReferenceNumber(res?.payload?.Data?.ReferenceNumber)
            clearSession()
        }

    }
    const loadDropDownOptions = async (field: any, FieldID: any, FilterString: any) => {
        let payload = {
            AuthenticationToken: authData?.AuthenticationToken,
            ManagerKey: authData?.ProfileManagerKey,
            "FieldID": FieldID,
            "ViewID": "900182",
            "FilterCompanyID": "0",
            "SelectString": "",
            "FilterString": FilterString,
            "SortString": "",
            "IsDistinct": "false",
            "PageNumber": "0",
            "PageSize": "50"
        }
        const res = await dispatch(getQuery(payload));

        if (res?.payload?.IsRequestSuccessful) {

            let formFields = fields.map((f: any) => {
                if (f.key === field) {
                    if (field === "serviceType") {
                        f.options = res?.payload?.Data?.Table?.filter((f: any) => f.ID == 38 || f.ID == 46 || f.ID == 47)
                    } else if (field === "serviceSubType") {
                        let response = res?.payload?.Data?.Table
                        f.options = response
                        f.value = response.length === 1 && response[0].ID
                    } else {
                        f.options = res?.payload?.Data?.Table
                    }
                    f.disabled = false
                }

                if (field === "dealer") {
                    f.disabled = false
                }

                if (f.key === "serviceSubType") {
                    f.disabled = true
                }

                return f;
            })
            setFormFields1([...formFields])

        }
    }
    const [vinRegErrorMsg, setVinRegErrorMsg] = useState("")
    const handleClosepopup = () => {
        setVinRegErrorMsg("");
    }
    const verify = async (e: any, key: any) => {
        e.preventDefault()
        loadDropDownOptions("state", "955287", "")
        loadDropDownOptions("serviceType", "941822", "")
        if (key === "regNo") {
            let payload = {
                AuthenticationToken: authData?.AuthenticationToken,
                ManagerKey: authData?.ProfileManagerKey,
                RegistrationNo: values.regNo,
                VIN: values.vin
            }
            const res = await dispatch(regNo(payload));

            if (res?.payload?.Data?.IsRequestSuccessful) {

                if (res?.payload?.Data?.ApplicableCampaign !== "") {
                    const input: string = res?.payload?.Data?.ApplicableCampaign

                    const resultArray: any = input.split(",");

                    const finalArray: any = resultArray.map((item: any) => item.trim());
                    setCampaignsData(finalArray);
                } else {
                    setCampaignsData([])
                }
                setDisabledMobileNo(false)
                setOtpVerifiedVINandREG(true)
                let { ModelName, Vin, RegistrationNo } = res?.payload.Data
                // setDisabledRegNo(true)
                setOriginalRegNo(RegistrationNo);
                setOriginalVin(Vin);
                let maskedRegNo = RegistrationNo && "X".repeat(RegistrationNo.length - 4) + RegistrationNo.slice(-4);
                let maskedVin = Vin && "X".repeat(Vin.length - 4) + Vin.slice(-4);

                if (values?.vin) {

                    setValues({ ...values, vin: Vin, model: ModelName, regNo: maskedRegNo });
                }
                if (values?.regNo) {
                    setValues({ ...values, vin: maskedVin, model: ModelName, regNo: RegistrationNo });

                }
                setVinRegErrorMsg("")

                let formFieldsUpdated = formFields.map((f: any) => {
                    if (f.key === "vin" && Vin) {

                        f.disabled = true
                    }
                    if (f.key === "model" && ModelName) {

                        f.disabled = true
                    }

                    return f;
                })
                setFormFields(formFieldsUpdated)
            }
            else {
                setValues({ ...values, vin: "", model: "" });
                setVinRegErrorMsg(res?.payload?.Data?.ErrorMessage)
                setOtpVerifiedVINandREG(false)
            }
        }
    }
    return (

        <div>
            <Header position={'static'} />
            <Grid container spacing={1} className={classes.bg}>
                <Grid item xs={12} sm={12} textAlign={'center'} className="formBackground" >
                    {!thankyou ?
                        <>
                            <Form style={{ padding: 10 }}>

                                <Grid container >
                                    <Grid item xs={12} sm={12} textAlign={'center'} marginTop={2}>

                                        <Typography variant="h5" className={classes.headings}>Book A Service</Typography>

                                    </Grid>
                                    <Grid item xs={12} sm={0} md={3}>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={6} textAlign={'center'} className={classes.root}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={4.7} textAlign={'left'}>
                                                <div style={{ marginBottom: '5px' }}>Vehicle Registration Number<span style={{ color: 'red' }}>*&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span></div>
                                                <Input
                                                    required={true}
                                                    placeholder={"eg. DLXXAAXXXX"}
                                                    name={"regNo"}
                                                    type={"text"}
                                                    value={values["regNo"]}
                                                    onChange={onInputChange}
                                                    error={errors["regNo"]}
                                                    size={'small'}
                                                    disabled={disableRegNo}
                                                ></Input>

                                            </Grid>
                                            <Grid item xs={12} sm={0.6} textAlign={'left'} alignSelf={'center'}>
                                                <div>&nbsp; OR</div>
                                            </Grid>
                                            <Grid item xs={12} sm={4.7} textAlign={'left'}>

                                                <div style={{ marginBottom: '5px' }}>VIN (Vehicle Identification Number) / Chassis Number <span style={{ color: 'red' }}>*</span></div>
                                                <Input
                                                    required={true}
                                                    // placeholder={"VIN"}
                                                    name={"vin"}
                                                    type={"text"}
                                                    value={values["vin"]}
                                                    onChange={onInputChange}
                                                    error={errors["vin"]}
                                                    size={'small'}
                                                    disabled={disableRegNo}
                                                    placeholder={"eg. MALAA82HR4M000000"}
                                                ></Input>

                                            </Grid>
                                            <Grid item xs={12} sm={2} textAlign={'left'}>
                                                <div style={{ marginBottom: '5px', visibility: 'hidden' }}>Verify lable Label<span style={{ color: 'red' }}></span></div>

                                                <Button
                                                    name="Verify"
                                                    disabled={values.regNo || values.vin ? false : true}
                                                    type="click"
                                                    size="medium"
                                                    onClick={(e: any) => {
                                                        verify(e, 'regNo');
                                                    }}
                                                />

                                            </Grid>

                                            {/* <Grid item xs={12} sm={12} textAlign={'left'}>
                                            <div><span style={{ color: 'red' }}>{vinRegErrorMsg}</span></div>
                                        </Grid> */}
                                            <Custompopup
                                                open={vinRegErrorMsg}
                                                title={vinRegErrorMsg}
                                                contenttext={"We are unable to find a vehicle based on information provided, You can try again or share your vehicle details using other options listed below."}
                                                handleClose={handleClosepopup}>

                                            </Custompopup>

                                            {verifiedVINandREG && formFields?.map((f: any) => {
                                                return <Grid item key={f.key} xs={12} sm={6} textAlign={'left'}>
                                                    <div style={{ marginBottom: '5px' }}>{f.label} </div>
                                                    <Input
                                                        required={f.required}
                                                        placeholder={f.label}
                                                        name={f.key}
                                                        type={f.type}
                                                        value={values[f.key]}
                                                        onChange={onInputChange}
                                                        error={errors[f.key]}
                                                        size={'small'}
                                                        disabled={f.disabled}
                                                    ></Input>
                                                </Grid>
                                            })}
                                            {(verifiedVINandREG && CampaignsData.length > 0) &&
                                                <Grid item xs={12} sm={12} md={12} sx={{ marginLeft: "0" }}>
                                                    <TableContainer
                                                        component={Paper}
                                                        style={{
                                                            width: "100%",
                                                            maxHeight: "140px", // Total container height
                                                            boxShadow: "none", // Remove Paper shadow if needed
                                                        }}
                                                    >
                                                        <Table
                                                            stickyHeader
                                                            sx={{
                                                                "& .MuiTableCell-root": {
                                                                    border: "none", // Remove all borders
                                                                },
                                                                "& .MuiTableRow-root": {
                                                                    height: "24px", // Reduce row size
                                                                },
                                                            }}
                                                        >
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell
                                                                        style={{
                                                                            backgroundColor: '#03025d',
                                                                            padding: "4px 2px",
                                                                            paddingLeft: "4px", // Adjust padding for smaller rows
                                                                        }}
                                                                        colSpan={2}
                                                                    >
                                                                        <Grid>
                                                                            <div style={{ color: "white", fontSize: "18px" }}>
                                                                                Applicable offers & Service Notes *
                                                                            </div>
                                                                        </Grid>
                                                                    </TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody
                                                                sx={{
                                                                    display: "block", // Make TableBody a block element
                                                                    maxHeight: "80px", // Set max height for scrolling
                                                                    overflowY: "auto", // Enable vertical scrolling
                                                                }}
                                                            >
                                                                {CampaignsData.map((item: any, index: number) => (
                                                                    <TableRow
                                                                        key={index}
                                                                        sx={{
                                                                            display: "table", // Ensure rows display correctly
                                                                            width: "100%", // Ensure rows span the table width
                                                                        }}
                                                                    >
                                                                        <TableCell
                                                                            sx={{
                                                                                width: "15px",
                                                                                padding: "4px 4px",
                                                                                fontSize: '13px'
                                                                            }}
                                                                        >
                                                                            {index + 1}
                                                                        </TableCell>
                                                                        <TableCell
                                                                            sx={{
                                                                                padding: "4px 8px", // Adjust padding
                                                                                textAlign: "left",
                                                                                fontSize: '13px'
                                                                            }}
                                                                        >
                                                                            {item}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>



                                                </Grid>}
                                        </Grid>

                                        <br />
                                        {verifiedVINandREG && <Grid container spacing={2}>

                                            <Grid item xs={12} sm={12} textAlign={'left'}><Typography color={'#00095b'} variant="h6">Personal Details</Typography><Divider /></Grid>
                                            <Grid item xs={12} sm={6} textAlign={'left'}>
                                                <div style={{ marginBottom: '5px' }}>Mobile Number <span style={{ color: 'red' }}>*</span></div>
                                                <Input
                                                    required={true}
                                                    placeholder={"Mobile Number"}
                                                    name={"mobileNumber"}
                                                    type={"number"}
                                                    value={values["mobileNumber"]}
                                                    onChange={onInputChange}
                                                    error={errors["mobileNumber"]}
                                                    size={'small'}
                                                    inputProps={{ min: "1" }}
                                                    style={{ paddingRight: 0 }}></Input>

                                            </Grid>

                                            {fields?.map((f: any) => {
                                                return f.type === "header" ?
                                                    <Grid item xs={12} sm={12} textAlign={'left'}><Typography color={'#00095b'} variant="h6">{f.label}</Typography><Divider /></Grid>

                                                    : <Grid item key={f.key} xs={12} sm={6} textAlign={'left'} style={{ "visibility": f.key === "serviceSubType" ? "hidden" : "unset" }}>
                                                        <div style={{ marginBottom: '5px' }}>{f.label} <span style={{ fontSize: "10px" }}>{f.key === "appointmentTime"}</span>{f.required && <span style={{ color: 'red' }}>*</span>}</div>


                                                        {f.type == "select" ? <FormControl fullWidth>

                                                            <Select
                                                                //labelId="demo-simple-select-label"
                                                                id={f.key}
                                                                value={f.value || values[f.key]}
                                                                placeholder={f.label}
                                                                size={'small'}
                                                                name={f.key}
                                                                onChange={onInputChange}
                                                                error={errors[f.key]}
                                                                displayEmpty
                                                                disabled={f.disabled}

                                                            >
                                                                <MenuItem disabled>
                                                                    {f.key === "serviceAdvisor" ? "No Selection" : "Select"}
                                                                </MenuItem>
                                                                {f.options?.map((i: any) => {
                                                                    return f.key === "dealer" ? <MenuItem key={i.BranchID} value={i.BranchID}>{i.BranchName}</MenuItem> :
                                                                        f.key === "state" ? <MenuItem key={i.StateID} value={i.StateID}>{i.StateName}</MenuItem> :
                                                                            f.key === "city" ? <MenuItem key={i.CityID} value={i.CityID}>{i.CityName}</MenuItem> :
                                                                                f.key === "serviceAdvisor" || f.key === "serviceType" || f.key === "serviceSubType" ? <MenuItem key={i.ID} value={i.ID}>{i.Name}</MenuItem> : <MenuItem value={i.value}>{i.label}</MenuItem>
                                                                })}
                                                            </Select>
                                                        </FormControl> :
                                                            f.type === "date" ?


                                                                // <Input
                                                                //     required={f.required}
                                                                //     disabled={f.disabled}
                                                                //     // label={f.label}

                                                                //     placeholder={f.placeholder}
                                                                //     name={f.key}
                                                                //     type={f.type}
                                                                //     value={values[f.key]}
                                                                //     onChange={onInputChange}

                                                                //     inputProps={{
                                                                //         daysOfWeekDisabled: [6],
                                                                //         min: moment().add(2, 'days').format("YYYY-MM-DD"),
                                                                //         max: moment().add(1, 'month').format("YYYY-MM-DD"),
                                                                //         onKeyDown: (event:any) => {
                                                                //             event.preventDefault();
                                                                //          },
                                                                //     }}
                                                                //     error={errors[f.key]}
                                                                //     size={'small'}

                                                                // ></Input> 
                                                                <MuiDatePicker
                                                                    label={f.placeholder}
                                                                    name={f.key}
                                                                    value={values[f.key]}
                                                                    onChange={onInputChange}
                                                                    renderInput={(e: any) => {
                                                                        e.preventDefault();
                                                                    }}
                                                                    placeholder={f.placeholder}
                                                                    required={f.required}
                                                                    disabled={f.disabled}
                                                                    // minDate ={moment().add(2, 'days').format("YYYY-MM-DD")}
                                                                    // maxDate={ moment().add(1, 'month').format("YYYY-MM-DD")}

                                                                    error={errors[f.key]}
                                                                    size={'small'}
                                                                />

                                                                : f.type === "time" ? <Input
                                                                    required={f.required}
                                                                    disabled={f.disabled}
                                                                    // label={f.label}
                                                                    placeholder={f.placeholder}
                                                                    name={f.key}
                                                                    type={f.type}
                                                                    value={values[f.key]}
                                                                    onChange={onInputChange}
                                                                    error={errors[f.key]}
                                                                    size={'small'}

                                                                ></Input> :
                                                                    <Input
                                                                        required={f.required}
                                                                        disabled={f.disabled}
                                                                        // label={f.label}
                                                                        placeholder={f.placeholder ? f.placeholder : f.label}
                                                                        name={f.key}
                                                                        type={f.type}
                                                                        value={values[f.key]}
                                                                        onChange={onInputChange}
                                                                        error={errors[f.key]}
                                                                        size={'small'}
                                                                        inputProps={{ min: 0 }}
                                                                    ></Input>}
                                                    </Grid>
                                            })}
                                        </Grid>}
                                    </Grid>
                                    <Grid container>
                                        <Grid item xs={12} sm={0} md={2}>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={8}>
                                            {/* <p>“This Online Service Booking facility is currently available for limited-service outlets only, we are on the process of expanding the same soon for other location(s)”</p> */}
                                        </Grid>
                                    </Grid>
                                    <Grid container>
                                        <Grid item xs={12} sm={0} md={2}>
                                        </Grid>

                                        {verifiedVINandREG && <><Grid item xs={12} sm={12} md={8} textAlign={'center'} marginTop={2}>
                                            <p>I agree to receive calls, e-mail and SMS from Ford India Private Limited (“Ford”),
                                                its agents, and its dealers on my mobile phone, which are intended to assist me in availing service. I also agree to receive such and any other marketing & product related communication from Ford, its agents, and its dealers until specified otherwise, by me.</p>
                                        </Grid>
                                            <Grid item xs={12} sm={12} textAlign={'center'} marginTop={2}>

                                                <Button
                                                    name="Submit"
                                                    disabled={
                                                         !(values.regNo || values.vin) ||
                                                        !values?.mobileNumber ||
                                                         values?.mobileNumber.length !== 10 ||
                                                        !values?.firstName ||
                                                        !values?.state ||
                                                        !values?.city ||
                                                        !values?.dealer ||
                                                        !values?.appointmentDate ||
                                                        !values?.appointmentTime ||
                                                        !values?.serviceType ||
                                                        (values?.email && !validateEmail(values?.email))||
                                                         errors?.appointmentTime
                                                    }
                                                    type="submit"
                                                    onClick={(e: any) => {
                                                        onSubmit(e);
                                                    }}
                                                    className={classes.buttun}
                                                />
                                            </Grid>
                                        </>}
                                    </Grid>



                                </Grid>

                            </Form>



                        </>
                        : <div>
                            <ThankYou referenceNumber={referenceNumber} />
                        </div>
                    }



                </Grid>

            </Grid>
            
           {/* {!thankyou && !verifiedVINandREG  && <Grid container>
                <Grid item xs={12} display={'flex'} justifyContent={'center'}>
                    {(!isMobile && !isTablet) && BannerImage && (<img
                        alt="Image1"
                        width={1200}
                        style={{ paddingLeft: '40px' }}
                        height={340}
                        src={BannerImage}
                    />)
                    }

                    {isMobile && BannerImageForMobile&&(
                        <img
                            alt="Image1"
                            width={350}
                            style={{ paddingLeft: '15px' }}
                            src={BannerImageForMobile}
                        />)
                    }

                    {(isTablet && !isMobile) &&
                        <img
                            alt="Image1"
                            width={800}
                            height={320}
                            style={{ paddingLeft: '30px' }}
                            src={BannerImage}
                        />}
                </Grid>
            </Grid>
            }*/}
        </div>
    );
};

export default AuthrizedAppointmentBooking;
